import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-generic-status',
  templateUrl: './generic-status.component.html',
  styleUrls: ['./generic-status.component.scss']
})
export class GenericStatusComponent implements OnInit {
    @Input() state = 'ok';
        
    constructor() { }

    ngOnInit(): void {
    }

}
